import {
  type Dispatch,
  type ReactElement,
  type SetStateAction,
  useState,
} from 'react';

export function InputField({
  label,
  disabled,
  value,
  type,
  errorMessage,
  update,
  ...props
}: {
  label: string;
  disabled: boolean;
  value?: number | string;
  type: string;
  errorMessage?: string;
  update: Dispatch<SetStateAction<number>>;
} & Record<string, any>): ReactElement {
  const [error, setError] = useState(false);

  const validate = (e) => {
    if (!e.target.value && !disabled) {
      update(0);
      setError(true);
    } else {
      setError(false);
      const num = Number(e.target.value);
      if (props.max && num > props.max) {
        update(props.max as number);
      } else {
        update(Number(e.target.value));
      }
    }
  };

  let modValue = value;
  if (type === 'number') {
    if (value) modValue = Number.parseInt(value as string);
    if (props.max && modValue && modValue > props.max)
      modValue = props.max as number;
  }

  return (
    <div className="relative mb-4 border-0 border-b border-solid border-[#dadbdc] bg-transparent">
      <label
        htmlFor={label}
        className="duration-250 absolute left-0 block origin-top-left scale-75
      cursor-text text-grey-dark opacity-50 dark:text-white"
      >
        {label}
      </label>
      {(!type || type === 'text') && (
        <input
          name={label}
          type="text"
          className="block w-full border-none bg-transparent px-2 py-6 font-bold text-grey-dark focus:outline-0 dark:text-white"
          required
          value={value}
          disabled={disabled}
          onBlur={validate}
          onInput={validate}
          {...props}
        />
      )}
      {type === 'number' && (
        <input
          type="number"
          className="block w-full border-none bg-transparent px-2 py-6 font-bold text-grey-dark focus:outline-0 dark:text-white"
          required
          value={modValue?.toString()}
          disabled={disabled}
          onBlur={validate}
          onInput={validate}
          {...props}
        />
      )}
      {error && (
        <span className="InputField__ErrorMessage">{errorMessage}</span>
      )}
    </div>
  );
}
